export interface User {
  token: string;
  comercioKey: string;
  email: string;
  timezone_iana: string;
}

interface AuthTokenClaims {
  email: string;
  comercio_key: string;
}

function decodeBase64Url(value: string): string {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  const bytes = Uint8Array.from(atob(padded), character => character.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function decodeAuthToken(token: string): AuthTokenClaims | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const claims = JSON.parse(decodeBase64Url(payload)) as Partial<AuthTokenClaims>;
    if (typeof claims.email !== 'string' || typeof claims.comercio_key !== 'string') return null;
    if (!claims.email.trim() || !claims.comercio_key.trim()) return null;
    return { email: claims.email, comercio_key: claims.comercio_key };
  } catch {
    return null;
  }
}

export function userFromToken(token: string, timezone_iana: string): User | null {
  const claims = decodeAuthToken(token);
  if (!claims) return null;
  return {
    token,
    comercioKey: claims.comercio_key,
    email: claims.email,
    timezone_iana,
  };
}
